import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
    background-color: #F3F3F3;
    overflow:hidden;
    &.closed {
        .public-layout-description {
            .headline {
                font-weight: 400;
            }
            .headline-mobile {
                font-weight: 400;
                text-align: left;
            }
        }
        .header-closed--mobile {
            padding: 7em 0 2em 0;
            border-bottom: 1px solid #000;
            display: none;
            @media(max-width:${vars.mobileL}) {
                background-color: #fff;
                display: block;
            }
        }
        .header-closed__container {
            padding:.4em 0.5em;
            display: flex;
            align-items: center;
            .title {
                font-size:1.3em;
                font-weight: 600;
                margin: 0 auto;
            }
        }
        .public-page-job-section-offers {
            padding-top: 10em;
        }
        .public-layout-jobs-medium-job-box {
            border-top: none;
        }
    }
    @media(max-width:${vars.mobileL}) {
        &.closed {
            .public-page-job-section-offers {
              padding-top: 2em;
              .headline-mobile {
                font-size: 1.7em;
                line-height: 1.5;
                margin-bottom: 1em;
              }
            }
        }
    }
    @media all and (max-width: ${vars.mobileM}) {
        background-color: #FFFFFF;
        overflow:hidden;
    }
`;